import resolvePromise from '../helper/resolved_promise';
import FilterOptionsConstants from '../constants/filter_options_contants';
import Dispatcher from '../dispatcher';

function updateFilterOptionsAction(updatedFilterOptions) {
    Dispatcher.handleFilterOptionsAction({
        type: FilterOptionsConstants.UPDATE_FILTER_OPTIONS_ACTION,
        payload: updatedFilterOptions
    });

    return resolvePromise();
}

function loadingOptionsAction(filtersToBeLoaded) {
    Dispatcher.handleFilterOptionsAction({
        type: FilterOptionsConstants.LOAD_FILTER_OPTIONS_ACTION,
        payload: filtersToBeLoaded
    });

    return resolvePromise();
}

function updateTyreSizeConfiguratorFilterOptionsAction(filtersToBeLoaded) {
    Dispatcher.handleTyreSizeConfiguratorFilterOptionsAction({
        type: FilterOptionsConstants.LOAD_TYRE_FILTER_OPTIONS_ACTION,
        payload: filtersToBeLoaded
    });

    return resolvePromise();
}

function updateTyreMotoSizeConfiguratorFilterOptionsAction(filtersToBeLoaded) {
    Dispatcher.handleTyreMotoSizeConfiguratorFilterOptionsAction({
        type: FilterOptionsConstants.LOAD_TYRE_MOTO_FILTER_OPTIONS_ACTION,
        payload: filtersToBeLoaded
    });

    return resolvePromise();
}

export {
    updateFilterOptionsAction,
    loadingOptionsAction,
    updateTyreSizeConfiguratorFilterOptionsAction,
    updateTyreMotoSizeConfiguratorFilterOptionsAction,
};